var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "white",
    d: "m10.96 9.843 2.44 1.408c.237.138.314.45.18.682a.494.494 0 0 1-.68.184l-2.48-1.432A1.5 1.5 0 1 1 9 8.085V3.503C9 3.225 9.232 3 9.5 3c.276 0 .5.233.5.503v4.582a1.5 1.5 0 0 1 .96 1.758M9.5 19a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.8ec29ce6a7c64b9d4538618c07b683fa.svg";
export { ForwardRef as ReactComponent };